import React, { Component } from 'react';
import {connect} from "react-redux";
import * as UserActions from "../actions/UserActions";
import {PRICE_PER_USER, TIER_FREE} from "../constants";
import moment from "moment";
import {Button, Glyphicon} from "react-bootstrap";
import * as InviteActions from "../actions/InviteActions";
import {LinkContainer} from "react-router-bootstrap";
import Loading from "../components/Loading";
import * as TeamActions from "../actions/TeamActions";


class TeamPage extends Component {

    constructor(){
        super();

        this.state = {
        }
    }

    componentWillMount(){
        this.loadData();
    }

    componentDidUpdate(){
        this.loadData();
    }

    loadData(){
        this.props.fetchUsersIfNeeded();
        this.props.fetchTeamInvitesIfNeeded();
        this.props.fetchBillingIfNeeded();
    }

    activateUser(userId){
        this.props.activateUser(userId);
    }
    deactivateUser(userId){
        this.props.deactivateUser(userId);
    }
    revokeInvitation(invitationId){
        this.props.revokeInvitation(invitationId);
    }

    render() {

        const {users, team, invites, billing} = this.props;

        const userArray = Object.values(users.items).sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
        const inviteArray = Object.values(invites.items);

        if(!team || (!users.fetched && users.fetching) || (!invites.fetched && invites.fetching)){
            return <Loading loading={true} center />
        }

        const newBillingCycle = team.tier !== TIER_FREE && billing && moment(billing.currentPeriod.end*1000).format("LL");

        return (
            <div className="card">
                <div className="card-heading">
                    <h1 className="card-title">
                        Team Management
                        <small>{team.name}</small>
                        {team.tier === TIER_FREE ? (
                            <LinkContainer to="/upgrade">
                                <Button bsStyle="primary" className="pull-right">Upgrade to premium</Button>
                            </LinkContainer>
                        ):(
                            <LinkContainer to = "/add-team-member" style={{marginRight: 5}}>
                                <Button bsStyle="primary" className="pull-right">
                                    <Glyphicon glyph="plus"/>&nbsp;
                                    Invite new user
                                </Button>
                            </LinkContainer>
                        )}
                        <LinkContainer to="/cancel" className="pull-right" style={{marginRight: "10px"}}>
                            <Button>Remove account / Downgrade</Button>
                        </LinkContainer>
                    </h1>
                </div>

                <div className="card-body">
                    {team.tier === TIER_FREE ? (
                        <p>
                            Team {team.name} is currently on the <strong>free tier</strong>. Teams on the free tier can only have one user. Please consider to upgrade your team to the premium tier if you want to add more users to your team.
                        </p>
                    ) : (
                        <p>
                            Team {team.name} is currently on the <strong>premium tier</strong> with {team.userCount} active users. You will be billed &euro;{parseFloat(Math.round(team.userCount * PRICE_PER_USER * 100) / 100).toFixed(2)} <em style={{fontSize: "8pt", letterSpacing: 0}}>(excluding 21% VAT)</em> monthly. Your next billing cycle will start on {newBillingCycle}.
                        </p>
                    )}
                </div>

                {(userArray.length > 1 || inviteArray.length > 0) && (
                    <table className="table table-striped">
                        <thead>
                        <tr>
                            <th>User</th>
                            <th>E-mail address</th>
                            <th />
                        </tr>
                        </thead>
                        <tbody>
                        {inviteArray.length > 0 && (
                            <tr>
                                <th colSpan={3}>Pending Invitations</th>
                            </tr>
                        )}
                        {inviteArray.map((invite, id) => {
                            return <tr key={invite.id}>
                                <td>
                                    {invite.name}
                                    {invite.error && (
                                        <div style={{color:"red",fontWeight:"bold"}}>{invite.error}</div>
                                    )}
                                </td>
                                <td>
                                    {invite.email}
                                </td>
                                <td style={{textAlign: "right"}}>
                                    <Button onClick={this.revokeInvitation.bind(this, invite.id)}>revoke</Button>
                                </td>
                            </tr>
                        })}
                        {inviteArray.length > 0 && (
                            <tr>
                                <th colSpan={3}>Current Users</th>
                            </tr>
                        )}
                        {(userArray.length > 1 || inviteArray.length > 0) && userArray.map((user, id) => {
                            return (<tr key={user.id}>
                                <td>
                                    {user.active ? (
                                        <span>{user.name}</span>
                                    ):(
                                        <span style={{textDecoration: "line-through"}}>{user.name}</span>
                                    )}
                                </td>
                                <td>
                                    {user.email}
                                </td>
                                <td style={{textAlign: "right"}}>
                                    {!user.admin && (
                                        <div>
                                            {user.active ? (
                                                <div>
                                                    {/*<Button>reset password</Button>*/}
                                                    <Button onClick={this.deactivateUser.bind(this, user.id)}>deactivate</Button>
                                                </div>
                                            ):(
                                                <Button onClick={this.activateUser.bind(this, user.id)}>activate</Button>
                                            )}
                                        </div>
                                    )}
                                </td>
                            </tr>)
                        })}
                        </tbody>
                    </table>
                )}
            </div>
        )
    }
}

export default connect(state => ({
    users: state.users,
    team: state.teams.active,
    invites: state.invites,
    billing: state.teams.billing,
    isPremium: state.teams && state.teams.active && state.teams.active.tier !== TIER_FREE,
}), dispatch => ({
    fetchTeamInvitesIfNeeded: () => dispatch(InviteActions.fetchTeamInvitesIfNeeded()),
    revokeInvitation: (invitationId) => dispatch(InviteActions.deleteInvite(invitationId)),
    fetchUsersIfNeeded: () => dispatch(UserActions.fetchUsersIfNeeded()),
    activateUser: (userId) => dispatch(UserActions.activateUser(userId)),
    deactivateUser: (userId) => dispatch(UserActions.deactivateUser(userId)),
    fetchBillingIfNeeded: () => dispatch(TeamActions.fetchBillingIfNeeded())
}))(TeamPage);


// WEBPACK FOOTER //
// ./src/pages/TeamPage.js